import { useSearchParams, Link } from "react-router-dom";
import { MailCheck, ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import { SITE } from "@/content/copy";
import { trackEvent } from "@/lib/analytics";

export default function ThankYouPage() {
  const [params] = useSearchParams();
  const source = params.get("source") || "checklist";
  const isChecklist = source === "checklist";

  return (
    <>
      <Seo title="Thank You | Clarus Partners" noindex />
      <main className="min-h-screen bg-background flex items-center">
        <div data-testid="thank-you-page" className="max-w-2xl mx-auto px-4 sm:px-6 py-24 text-center">
          <div className="mx-auto w-16 h-16 rounded-full bg-terracotta-light flex items-center justify-center">
            <MailCheck className="w-8 h-8 text-terracotta" aria-hidden="true" />
          </div>
          {isChecklist ? (
            <>
              <h1 className="mt-8 text-3xl sm:text-4xl font-extrabold tracking-tight text-navy">
                You're in - check your inbox
              </h1>
              <p className="mt-4 text-lg text-navy/70 leading-relaxed">
                Your Xero Health Check Checklist is on its way. Run through it tonight - it takes about 30 minutes.
              </p>
            </>
          ) : (
            <>
              <h1 className="mt-8 text-3xl sm:text-4xl font-extrabold tracking-tight text-navy">
                Thanks - we've got your enquiry
              </h1>
              <p className="mt-4 text-lg text-navy/70 leading-relaxed">
                Nima will get back to you within one business day. Keep an eye on your inbox for a confirmation email.
              </p>
            </>
          )}

          <div className="mt-10 rounded-2xl bg-white border border-border p-8">
            <h2 className="text-xl font-bold text-navy">While you're here - want to talk it through?</h2>
            <p className="mt-2 text-base text-navy/70">
              Book a free 30-minute consultation and leave with a clear next step, whether we work together or not.
            </p>
            <a
              href={SITE.calendlyUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="thank-you-book-button"
              onClick={() => trackEvent("book_consultation_click", { location: "thank_you" })}
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-terracotta px-8 py-4 text-base font-bold text-white transition-all duration-300 hover:bg-terracotta-hover hover:-translate-y-0.5 hover:shadow-lg"
            >
              {SITE.consultLabel} <ArrowRight className="w-4 h-4" aria-hidden="true" />
            </a>
          </div>

          <Link
            to="/"
            data-testid="thank-you-home-link"
            className="mt-8 inline-block text-sm font-semibold text-navy/60 hover:text-navy transition-colors"
          >
            ← Back to claruspartners.com.au
          </Link>
        </div>
      </main>
    </>
  );
}
